import React, {useCallback} from 'react';

import styles from './FilterMenu.module.scss';
import useAnimatedVisibility from '../../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';

const FilterMenuOption = props => {
    const {className = '', href, option, visible, children, onClick} = props,
        {mounted, visible: isVisible, showing, hiding} = useAnimatedVisibility({
            visible,
            timeout: 1000,
        });

    const handleClick = useCallback(() => {
        if (onClick) onClick(option);
        if (href) {
            app.history.push(href);
        }
    }, [option, onClick]);

    if (!mounted) return null;

    return (
        <button
            className={[styles.option, className, isVisible ? styles.visible : styles.hidden, showing ? styles.showing : '', hiding ? styles.hiding : ''].join(
                ' '
            )}
            type="button"
            onClick={handleClick}>
            {option?.label || children}
        </button>
    );
};

export default FilterMenuOption;
